var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('about-mycolor-mobile',{staticClass:"u-only--sp p-about-mycolor--sp",attrs:{"tag":_vm.tag}}),_vm._v(" "),_c('about-mycolor-pc',{staticClass:"u-only--pc",attrs:{"tag":_vm.tag}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }